export function farmMapping(address) {
  const mapping = {
    '0x0650caf159c5a49f711e8169d4336ecb9b950275': 'sky_farm',
    '0x10ab606b067c9c461d8893c47c7512472e19e2ce': 'chronicle_farm',
    '0xe58cbe144dd5556c84874dec1b3f2d0d6ac45f1b': 'lse_farm',
    '0x9581c795dbcaf408e477f6f1908a41be43093122': 'lse_farm',
    '0x90a3b384f62f43ba07938ea43aeec35c2abfeca2': 'spk_farm',
    '0x173e314c7635b45322cd8cb14f44b312e079f3af': 'spk_farm',
    '0x4e41488c19cd35eb4de3083fc3e204854c75c86a': 'grove_farm'
  };

  return mapping[address];
}
